import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import {
  requestEmailVerificationLink,
  triggerLogout,
} from '@atom/actions/userActions';
import Logo from '@atom/components/common/navigation/Logo';
import { useNavigation } from '@atom/hooks/useNavigation';
import { AppBar, Box, Button, Icon, Toolbar } from '@atom/mui';
import { EmailIcon, LinkIcon, PersonIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import layoutStyles from '@atom/styles/layout';
import accountUtilities from '@atom/utilities/accountUtilities';

import LoginFooter from './LoginFooter';

import classes from './login.module.css';

const navBarStyle = {
  height: layoutStyles.topNavHeight,
  backgroundColor: colors.neutral.white,
  boxShadow: '0 2px 4px 1px',
  color: colors.utility.boxShadow,
  position: 'fixed',
  top: 0,
};

const styles = {
  titleStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  activeIcon: {
    fontSize: '24px',
    color: colors.neutral.white,
  },
  inactiveIcon: {
    fontSize: '24px',
    color: colors.neutral.gray,
  },
};

const VerifyEmail = () => {
  const [, { navigate }] = useNavigation();
  const email = accountUtilities.getLoggedInEmail();
  if (!email) {
    navigate('/login');
  }

  const dispatch = useDispatch();

  const submit = () => {
    dispatch(requestEmailVerificationLink());
  };

  const logout = () => {
    dispatch(triggerLogout());
  };

  return (
    <>
      <AppBar style={navBarStyle}>
        <Toolbar>
          <div>
            <Logo />
          </div>
          <Box sx={{ flexGrow: 1 }} />
          <div className={classes.navRightContainer}>
            <div className={classes.navRightText}>{email}</div>
            <div className={classes.navRightLogin} onClick={logout}>
              Sign Out
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.container}>
        <div className={clsx(classes.authBackground, classes.partial)} />
        <div className={classes.headingText}>Verify</div>
        <div className={classes.registrationIconContainer}>
          <div className={clsx(classes.registrationIcon, classes.active)}>
            <Icon style={styles.activeIcon} icon={PersonIcon} />
          </div>
          <div className={clsx(classes.registrationIcon, classes.active)}>
            <Icon style={styles.activeIcon} icon={EmailIcon} />
          </div>
          <div className={classes.registrationIcon}>
            <Icon style={styles.inactiveIcon} icon={LinkIcon} />
          </div>
        </div>
        <div className={classes.iconHorizontalBarContainer}>
          <div
            className={clsx(classes.iconHorizontalBarHalf, classes.active)}
          />
          <div className={classes.iconHorizontalBarHalf} />
        </div>
        <div className={classes.textFieldContainer}>
          <div>
            Thank you for signing up! You will receive an email with a
            verification link. Please continue your signup process after
            verifying.
          </div>
          <div className={classes.textBlock}>
            If you have any questions, please contact Atom customer service
            at&nbsp;
            <a href="mailto:support@goatomapp.com">support@goatomapp.com</a>.
          </div>
        </div>
        <div className={classes.verifyEmailButtonSection}>
          <div className={classes.verifyEmailText}>
            Already Verified? Please log back in again.
          </div>
          <Button color="primary" variant="contained" onClick={logout}>
            Back To Login
          </Button>
        </div>
        <div className={classes.verifyEmailButtonSection}>
          <div className={classes.verifyEmailText}>
            Didn't receive an email from us?
          </div>
          <Button color="inherit" variant="contained" onClick={submit}>
            Resend Email
          </Button>
        </div>
        <LoginFooter />
      </div>
    </>
  );
};

export default VerifyEmail;
